import { Component, OnInit, inject } from '@angular/core'
import { MessageService } from 'primeng/api'
import { ToastService } from 'src/app/data/services/components/toast/toast.service'
import { PrimeIcon } from 'src/app/domain/enums/components/prime-icons.enum'
import { Toast } from 'src/app/domain/interfaces/components/toast.interface'

const LOADING_TOAST_KEY = 'loading'

@Component({ selector: 'app-toast', templateUrl: './toast.component.html', styleUrls: ['./toast.component.scss'], providers: [MessageService] })
export class ToastComponent implements OnInit {
  private messageService: MessageService = inject(MessageService)
  private toastService: ToastService = inject(ToastService)

  public ngOnInit(): void {
    this.toastService.toastSubject.subscribe((toast: Toast) => {
      this.showToast(toast)
    })
    this.toastService.loadingToastSubject.subscribe((message: string | null) => {
      this.messageService.clear(LOADING_TOAST_KEY)
      if (message) this.messageService.add({ key: LOADING_TOAST_KEY, severity: 'loading', summary: 'Carregando', detail: message, icon: PrimeIcon.LOADING, sticky: true, closable: false })
    })
  }

  private showToast(toast: Toast): void {
    const interpretNewLinesConfig = toast.interpretNewLines ? { styleClass: 'toast-interpret-newlines' } : {}

    switch (toast.severity) {
      case 'success':
        this.messageService.add({ severity: toast.severity, summary: 'Sucesso', detail: toast.message, ...interpretNewLinesConfig })
        break
      case 'error':
        this.messageService.add({ severity: toast.severity, summary: 'Erro', detail: toast.message, ...interpretNewLinesConfig })
        break
      case 'warn':
        this.messageService.add({ severity: toast.severity, summary: 'Atenção', detail: toast.message, ...interpretNewLinesConfig })
        break
      case 'info':
        this.messageService.add({ severity: toast.severity, summary: 'Aviso', detail: toast.message, ...interpretNewLinesConfig })
        break
    }
  }
}
